import React, { useEffect } from 'react'
import FindingList from './FindingList'
import SettingImpression from './SettingImpression'
import FindingImpression from './FindingImpression'
import { examFindingReset } from '../../../../../redux/actions/exam/examFindingActions'
import { useDispatch } from 'react-redux'

let dropdownTypeGlobal = ''
export default function FindingDropdowns(props) {
  const { findings, activeTestType, dropdownType, activeFieldType, handleFieldFocus, name, activeFieldKey, isHeaderModule } = props
  const wrapperClasses = "bg-white overflow-auto max-height-25 w-100 shadow border px-5 pt-5 position-absolute z-index-2"
  const dispatch = useDispatch()

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    dropdownTypeGlobal = dropdownType
  }, [dropdownType])

  const handleClickOutside = (event) => {
    const allowAutoDiagnosis = document.getElementById('allow_auto_diagnosis')
    const addFindingBtn = document.getElementById('add_finding_button')
    const reset = allowAutoDiagnosis && !allowAutoDiagnosis.contains(event.target) && !(addFindingBtn && addFindingBtn.contains(event.target))
    if (reset && dropdownTypeGlobal !== 'finding_impression') {
      // as per client requirement don't allow outside click close for dropdown type 'finding_impression'
      // let the close flow rely on back Finding button
      dispatch(examFindingReset({}))
    }
  }

  const getShow = () => {
    if (name.includes('hpis_attributes[')) {
      if (isHeaderModule) {
        return activeFieldKey === 'header.' + name
      }
      return activeFieldKey === name
    }
    return activeFieldType === activeTestType
  }

  const addId = getShow()
  const showImpressionDropdown = (dropdownType === 'finding_impression')
  const showSettingDropdown = (dropdownType === 'impression_settings')
  const showFindingList = (findings && activeTestType === findings[0]?.test_type && dropdownType === 'finding')

  return (
    <div id={addId ? 'allow_auto_diagnosis' : false}>
      {(showFindingList && getShow()) && <FindingList name={props.name} findings={findings} wrapperClasses={`${props.wrapperClasses} ${wrapperClasses}`} isHeaderModule={isHeaderModule} />}
      {(showSettingDropdown && getShow()) && <SettingImpression wrapperClasses={wrapperClasses} />}
      {(showImpressionDropdown && getShow()) && <FindingImpression wrapperClasses={wrapperClasses} handleFieldFocus={handleFieldFocus} name={name} />}
    </div>
  )
}